const INFO = {
  PERSONAL_PAN_INFO : "For sole proprietorships, we require the name of the proprietor", 
  COMPANY_PAN_INFO  : "The name of the legal entity.",
};

export default INFO;
